export const policyRecordStyle = {
    display: 'flex',
    fontSize: "13px"
};

export const defaultFontText = {
    fontSize: "13px",
    fontFamily: "Arial,Helvetica,sans-serif",
};

export const defaultH3Text = {
    fontSize: "20px",
    fontFamily: "Arial,Helvetica,sans-serif",
    marginTop: "12px",
};

export const breadcrumbStyle = {
    fontSize: "12px",
    fontFamily: "Arial,Helvetica,sans-serif",
    paddingBottom: '10px',
    paddingTop: '10px'
};

export const breadcrumbLinkStyle = {
    color: "#6ac61c",
    textDecoration: "none",
    marginRight: "5px",
    marginLeft: "5px",
    fontWeight: "700",
};

export const breadcrumbTextStyle = {
    color: "#000",
    marginLeft: "5px",
    fontWeight: "500",
};

export const titleStyle = {
    color: "#192225",
    fontSize: "40px",
    fontFamily: "'Pluto Sans', Arial, Helvetica, sans-serif",
};

export const boldLabel = {
    fontWeight: 'bold',
};

export const linkButton = {
    textDecoration: 'none',
};

export const buttonStyle = {
    fontSize: "12px",
    textTransform: "none",
    fontFamily: "'Pluto Sans', Arial, Helvetica, sans-serif",
    fontWeight: '600',
    borderRadius: '4px',
    color: '#000'
};

export const overviewRowLayout = {
    fontSize: "13px",
    fontFamily: "Arial,Helvetica,sans-serif",
    width: "100%",
};

export const overviewFlexContainer = {
    marginTop: "8px",
    marginBottom: "8px"
};

export const toastDiv = {
    position: 'fixed',
    top: '10px',
    right: '10px',
};

export const toastBanner = {
    marginBottom: ".75rem",
    fontSize: ".875rem",
};

export const toastHeader = {
    color: "#FFF",
    backgroundColor: "#F15A24",
    borderBottomLeftRadius: "calc(.25rem - 1px)",
    borderBottomRightRadius: "calc(.25rem - 1px)",
    display: "flex",
};

export const toastFail = {
    color: "#FFF",
    padding: ".45rem .75rem",
    alignItems: "center",
    backgroundColor: "#F15A24",
    borderBottomLeftRadius: "calc(.25rem - 1px)",
    borderBottomRightRadius: "calc(.25rem - 1px)",
}

export const toastSuccess = {
    color: "#FFF",
    padding: ".45rem .75rem",
    alignItems: "center",
    backgroundColor: "#6ac61c",
    borderBottomLeftRadius: "calc(.25rem - 1px)",
    borderBottomRightRadius: "calc(.25rem - 1px)",
}

export const toastButton = { 
    color: '#FFF', 
    opacity: '1', 
    marginLeft: '.5rem' 
};

export const headerSection = {
    maxWidth: '1200px',
    margin: 'auto',
    paddingBottom: '15px',
};

export const overviewSection = {
    maxWidth: '1200px',
    margin: 'auto',
    paddingBottom: '25px',
};

export const policyRecordSection = {
    flex: '1 1 0px',
    backgroundColor: '#fff'
};

export const headerOverviewSection = {
    backgroundColor: "#fff",
    paddingTop: '10px',
    paddingBottom: '100px',
};

export const recordDetailsSection = {
    maxWidth: '1200px',
    margin: 'auto',
    paddingBottom: '30px',
    marginTop: '-59px'
};

export const coverDetailLayout = {
    fontSize: "13px",
    fontFamily: "Arial,Helvetica,sans-serif",
    paddingBottom: '20px'
};

export const coverDetailEvenRow = {
    backgroundColor: "#ededed",
    width: '50%',
    padding: '8px',
    margin: '0',
};

export const coverDetailOddRow = {
    width: '50%',
    padding: '8px',
    margin: '0'
};

export const subSectionTitle = {
    paddingTop: "15px",
};

export const subSectionTopLine = {
    marginTop: 0,
};

export const subSectionMinHeight = {
    minHeight: 'calc(100vh - 315px - 54px)'
}

export const tableHeaderText = {
    fontSize: "13px",
    fontWeight: "bold",
    fontFamily: "Arial,Helvetica,sans-serif",
    backgroundColor: "#ededed",
    padding: "15px 0",
    margin: 0,
    border: "1px solid #ddd"
};

export const tableBodyOddRow = {
    fontSize: "13px",
    fontFamily: "Arial,Helvetica,sans-serif",
    backgroundColor: "#ededed",
    padding: "15px 0",
    margin: "0",
    border: "1px solid #ddd",
};

export const tableBodyEvenRow = {
    fontSize: "13px",
    fontFamily: "Arial,Helvetica,sans-serif",
    backgroundColor: "#ffffff",
    padding: "15px 0",
    margin: "0",
    border: "1px solid #ddd",
};

export const tableBodyText = {
    position: "absolute",
    top: "50%",
    transform: "translate(0, -50%)",
};

export const tableBodyDownloadLink = {
    float: "right",
    paddingRight: "40px",
    color: "#6ac61c",
    textDecoration: "none",
};

export const tableBodyDownloadLinkIcon = {
    color: "#999997",
    textDecoration: "none",
};

export const pointerCursor = {
    cursor: "pointer",
};

export const noTextDecoration = {
    textDecoration: "none",
};

export const requestPolicyForm = {
    fieldGutter: '30px',
    formFieldWidth: '500px',
    formLabelWidth: '180px',

};

export const paginationRow = {
    padding: "20px",
    width: "700px",
    margin: "auto",
    textAlign: "center",
}

export const leftNavContainer = {
    backgroundColor: '#59646b',
    minHeight: '100%',
    width: '300px',
    padding: '0',
};

export const leftNavHeader = {
    display: 'flex',
    alignItems: 'center'
};

export const leftNavHeaderBackIcon = {
    margin: '10px 0 10px 10px',
    textDecoration: "none",
};

export const leftNavHeaderText = {
    color: '#ffffff',
    paddingLeft: '8px',
    margin: '10px',
    textDecoration: "none",
    fontWeight: "bold",
};

export const leftNavInsuredNameText = {
    color: '#ffffff',
    margin: '10px',
    textDecoration: "none",
    fontWeight: "bold",
    width: "240px",
};

export const leftNavProductPolicy = {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#6ac61c',
};

export const leftNavProductPolicyText = {
    color: '#000000',
    margin: '10px',
    textDecoration: "none",
    fontWeight: "bold",
    width: "240px",
};

export const leftNavAccordionIcon = {
    paddingLeft: '8px',
    paddingBottom: '5px',
    margin: '10px',
    textDecoration: "none",
};

export const leftNavAccordionBox = {
    backgroundColor: '#445058',
    marginRight: 0,
};
export const addressGroupPadding = {
    paddingTop: '20px'
}

export const firstAddressPadding = {
    height: '60px'
}

export const addressFieldPadding = {
    height: '40px'
}

export const disclaimers = {
    paddingBottom: '34px'
};

export const brandColour = '#6ac61c';

export const iconTextAlign = {
    paddingLeft: '46px',
};

export const existingBusinessQuote = {
    color: '#ffffff',
    paddingLeft: '8px',
    margin: '9px',
    textDecoration: "none",
    fontWeight: "bold",
};

export const headerPadding = {
    paddingLeft: '16px'
};

export const verticalLine = {
    borderLeft: 'thick solid black',
    borderLeftWidth: '7px',
    marginLeft: '25px',
    marginBottom: '50px',
    marginTop: '10px'
  };
  
  export const title = {
    textAlign: 'left',
    marginLeft: '14px'
  };
  
  export const subTitle = {
    textAlign: 'left',
    marginLeft: '46px',
    marginBottom:'25px'
  };
  
  export const image = {
    float: 'right',
    marginRight: '80px',
    width: '15%',
    marginTop: '-10px'
  };

  export const subPlan = {
    wordSpacing: '1px'
  }
  
  export const overviewItem = {
    paddingBottom: '15px',
    display:'flex'
  };
  
  export const itemLabel = {
    fontWeight: 'bold',
    marginLeft: '50px',
    display: 'inline-block',
    width: '50%'
  };
  
  export const itemValue = {
    marginRight: 'auto',
    marginLeft: '15px',
    width: '50%'
  };
  
  export const summary = {
    marginLeft: '46px',
    fontWeight: 'bold',
    fontSize: '17px'
  };
  
  export const summaryName = {
    marginLeft: '2px',
    fontWeight: 'bold',
    fontSize: '20px'
  };
  
  export const hr = {
    width: '67%',
    marginTop: '0px',
    marginLeft: '0px',
    borderTop: 'solid 2px black',
  };
  
  export const table = {
    width: '65%',
    height: '50px',
    borderCollapse: 'collapse',
    marginBottom: '50px',
    marginLeft: '39px'
  };
  
  export const td = {
    border: '1px solid black',
    textAlign: 'left',
    fontSize: '15px',
    width: '6%',
    marginBottom: '13px',
    color: 'black',
    borderTop: '0px',
    paddingLeft: '14px'
  };

  export const th = {
    border: '1px solid black',
    textAlign: 'left',
    fontSize: '15px',
    width: '6%',
    marginBottom: '20px',
    paddingLeft: '14px'
  };
  
  export const plan = {
    fontSize: '15px',
    fontWeight: 'bold',
  };
  
  export const policyDetails = {
    width: '50%',
    paddingRight: '60px'
  };

  export const coc = {
    color: 'black'
  };

  export const printIcon = {
    float:'right', 
    marginRight: '80px', 
    width:'60px', 
    height:'60px',
    display: 'block',
    marginTop: '20px'
  }

  export const footer = {
    marginLeft: "35px",
    fontSize: "18px",
    marginBottom: "25px"
  }

  export const boldLabelWithFlex = {
    display: 'flex',
    fontWeight: 'bold'
  }

  export const flex ={
    display: 'flex'
  }

  export const planWithPadding = {
    fontSize: '15px',
    fontWeight: 'bold',
    paddingLeft: '40px'
  }

  export const planWithExtraPadding = {
    fontSize: '15px',
    fontWeight: 'bold',
    paddingLeft: '100px'
  }
  
export * from './Styles';